<template>
  <div class="wrapper" v-on:scroll="scrollFunction">
    <topHeader :scrolled="scrolled" :scrollNum="scrollNum"></topHeader>
    <div class="main" :class="headerClass">
      <router-view></router-view>
    </div>
    <uiFooter></uiFooter>
    <div class="devicetips" v-if="needtips && notice">
      <img :src="devicetips">
      <p>For best browsing experience, please use portrait mode.</p>
      <span class="closeButton" @click="notice = false" v-text="'CLOSE'"></span>
    </div>
  </div>
</template>

<script>
import topHeader from '@/components/Layout/topHeader'
import uiFooter from '@/components/Layout/footer'

const devicetips = require('@/assets/devicetips.gif');
export default {
  name: 'Root',
  components: {topHeader, uiFooter},
  data: function () {
    return {
      devicetips: devicetips,
      scrolled: false,
      scrollNum: 0,
      screenWidth: 0,
      screenHeight: 0,
      notice: true,
      device: this.$dataManager.getDevice(),
    }
  },
  computed: {
    headerClass() {
      return ((this.$route.name === 'pokerDetail' || this.$route.name === 'minigameDetail') && !this.scrolled) ? 'nav-empty' : ''
    },
    needtips() {
      return (this.device == 'mobile' && this.screenWidth <992) ? (this.screenWidth > this.screenHeight) ? true : false : false;
    }
  },
  methods: {
    scrollFunction: function (el) {
      var top = window.pageYOffset
      this.scrollNum = top
      this.scrolled = (top > 100) ? true : false
    },
  },
  mounted: function () {
    var $this = this
    $this.screenWidth = window.innerWidth
    $this.screenHeight = window.innerHeight
    window.onresize = () => {
      return (() => {
        $this.screenWidth = window.innerWidth
        $this.screenHeight = window.innerHeight
      })()
    }

    window.addEventListener("orientationchange", function () {
      $this.$bus.$emit('orientationchange',true)
      setTimeout(function (){
        $this.screenWidth = window.innerWidth
        $this.screenHeight = window.innerHeight
      },200)
    });
  },
  created() {
    window.addEventListener("scroll", this.scrollFunction);
  },
}
</script>

<style lang="scss" scoped>
@import '../style/_root';

.wrapper {
  width: 100vw;
  height: 100%;
  overflow-x: hidden;

  .main {
    //padding-top: 100px;

    &.nav-empty {
      padding-top: 0;
    }
  }
}

</style>
